import React from "react";
import Select, {SingleValue, StylesConfig} from "react-select";

import ErrorMessage from "../errorMessage/ErrorMessage";

import {Option} from "./DropdownHelper";

import styles from "./Dropdown.module.scss";

type DropdownProps = {
  id?: string;
  classname?: string;
  selectClassname?: string;
  title?: string;
  options: Option[];
  value: SingleValue<Option> | null;
  onChange: (value: SingleValue<Option>) => void;
  error?: string;
  placeholder?: string;
  indicator?: boolean;
};

export default function Dropdown({
  id = "",
  classname = "",
  selectClassname = "",
  title = "",
  options,
  value,
  onChange,
  error = "",
  placeholder = "Select",
  indicator = false,
}: DropdownProps) {
  const selectComponents = indicator
    ? {IndicatorSeparator: () => null}
    : {
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      };

  const isMobile = window.innerWidth < 768;

  const customStyles: StylesConfig<Option, boolean> = {
    option: (provided, state) => ({
      ...provided,
      color: "#2d2c2b",
      backgroundColor: state.isSelected
        ? "#f7f7f7"
        : state.isFocused
          ? "#f7f7f7"
          : "#ffffff",
      margin: "0px",
      fontWeight: "400",
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#b1b1b1",
      borderWidth: "1.5px",
      minHeight: "50px",
      fontWeight: "400",
      borderRadius: isMobile ? "24px" : "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0px",
      borderRadius: "5px",
      maxHeight: "200px",
      scrollbarColor: "#f1f1f1 transparent",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "5px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#b1b1b1",
    }),
  };

  const Header = () => (
    <div className={styles.header}>
      {title && <p className={styles.title}>{title}</p>}
      {error && <ErrorMessage data-testid={error} message={error} />}
    </div>
  );

  return (
    <div className={`${styles.container} ${classname}`}>
      <Header />
      <Select
        id={id}
        className={`${styles.customSelect} ${selectClassname}`}
        components={selectComponents}
        value={value}
        options={options}
        onChange={(selected) => {
          onChange(selected as SingleValue<Option>);
        }}
        placeholder={placeholder}
        styles={customStyles}
      />
    </div>
  );
}
